import Typography from '@mui/material/Typography';
import FileCopyOutlinedIcon from '@mui/icons-material/FileCopyOutlined';
import { CONSTANTS } from '../../../constants/constants';
import { useContext } from 'react';
import { useSnackbar } from 'notistack';
import { ComponentContext } from '../../../ContextWrappers/NRComponentContextWrapper';
import ReportBreadcrumbStyles from './ReportBreadcrumb.styles';
import makeStyles from '@mui/styles/makeStyles';
const useStyles = makeStyles(ReportBreadcrumbStyles);

export default function ReportBreadcrumb({ params }) {
  const classes = useStyles();
  const { enqueueSnackbar } = useSnackbar();
  const { asset } = useContext(ComponentContext);

  const onCopyJobGUID = () => {
    navigator.clipboard.writeText(window.location.href);
    enqueueSnackbar(CONSTANTS.REPORT_URL_COPIED, {
      variant: 'success',
      preventDuplicate: true,
      autoHideDuration: 1000
    });
  };

  if (!asset?.name) return null;

  return (
    <Typography variant="body2" component="span" className={classes.cursor} onClick={onCopyJobGUID}>
      {asset.name}
      <FileCopyOutlinedIcon className={classes.icon} />
    </Typography>
  );
}
